import moment from "moment";
import { AssessmentPeriodDTO, ContributionLevel, UserDTO } from '@/models';
import { REWARD_REQUEST_STATUSES } from "@/constants";

export const compareNumber = (value1: number, value2: number): number => {
  return value1 - value2;
};

export const compareText = (value1: string, value2: string): number => {
  return value1.localeCompare(value2);
};

export const compareUser = (value1: UserDTO, value2: UserDTO): number => {
  return value1.fullName.localeCompare(value2.fullName);
};

export const compareContributionLevel = (value1: ContributionLevel, value2: ContributionLevel): number => {
  return (value1.max || 0) - (value2.max || 0); // TODO: Check this logic
};

export const compareAssessmentPeriod = (value1: AssessmentPeriodDTO, value2: AssessmentPeriodDTO): number => {
  return value1.name.localeCompare(value2.name);
};

export const sortArrByNumberField = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((obj1: T, obj2: T): number => {
    const value1 = ((obj1[field] as unknown) as number) || 0;
    const value2 = ((obj2[field] as unknown) as number) || 0;
    return multiplier * compareNumber(value1, value2);
  });
};

export const sortArrByTextField = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((obj1: T, obj2: T): number => {
    const value1 = ((obj1[field] as unknown) as string) || '';
    const value2 = ((obj2[field] as unknown) as string) || '';
    return multiplier * compareText(value1, value2);
  });
};

export const sortArrByUserDTOField = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((obj1: T, obj2: T): number => {
    const value1 = ((obj1[field] as unknown) as UserDTO) || ({} as UserDTO);
    const value2 = ((obj2[field] as unknown) as UserDTO) || ({} as UserDTO);
    return multiplier * compareUser(value1, value2);
  });
};

export const sortArrByContributionLevelField = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((obj1: T, obj2: T): number => {
    const value1 = ((obj1[field] as unknown) as ContributionLevel) || ({} as ContributionLevel);
    const value2 = ((obj2[field] as unknown) as ContributionLevel) || ({} as ContributionLevel);
    return multiplier * compareContributionLevel(value1, value2);
  });
};

export const sortArrByAssessmentPeriodDTOField = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((obj1: T, obj2: T): number => {
    const value1 = ((obj1[field] as unknown) as AssessmentPeriodDTO) || ({} as AssessmentPeriodDTO);
    const value2 = ((obj2[field] as unknown) as AssessmentPeriodDTO) || ({} as AssessmentPeriodDTO);
    return multiplier * compareAssessmentPeriod(value1, value2);
  });
};

const rewardRequestStatuses = [
  REWARD_REQUEST_STATUSES.PENDING.label,
  REWARD_REQUEST_STATUSES.IN_PROGRESS.label,
  REWARD_REQUEST_STATUSES.APPROVED.label,
  REWARD_REQUEST_STATUSES.REJECTED.label
];

export const compareRewardRequestStatus = (status1: string, status2: string): number => {
  const index1 = rewardRequestStatuses.indexOf(status1);
  const index2 = rewardRequestStatuses.indexOf(status2);
  if (index1 === index2) {
    return 0;
  }
  return index1 > index2 ? 1 : -1;

}

export const sortArrByRewardRequestStatus = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((obj1: T, obj2: T): number => {
    const value1 = ((obj1[field] as unknown) as string) || '';
    const value2 = ((obj2[field] as unknown) as string) || '';
    return multiplier * compareRewardRequestStatus(value1, value2);
  });
};

export const sortArrayByDateField = <T>(arr: Array<T>, field: keyof T, isDesc: boolean): Array<T> => {
  const multiplier = isDesc ? -1 : 1;
  return arr.sort((item1, item2) => {
    if (item1[field] === item2[field]) {
      return 0;
    }
    return multiplier * (moment(item1[field]).isBefore(item2[field]) ? 1 : -1);
  });
};
